module.exports = __webpack_public_path__ + "static/media/bull_put_spread.c409325c.png";